import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { ButtonWithLabel } from './button_with_label';
import { styled, useSensor } from '@streem/ui-react';
import { Menu } from './menu';
import { useButtonWithMenu } from '../../../../../hooks/use_button_with_menu';
export function ButtonWithMenu({ onRequeueTrade, onClick, ...rest }) {
    const { showMenuYn, click, requeueTrade, closeMenu } = useButtonWithMenu(onRequeueTrade, onClick);
    return (_jsx(ButtonWithMenuView, { onClick: click, onRequeueTrade: requeueTrade, showMenuYn: showMenuYn, closeMenu: closeMenu, ...rest }));
}
function ButtonWithMenuView({ roundRightEdgeYn, disabled, onClick, trades, buttonStyle, showMenuYn, onRequeueTrade, closeMenu, }) {
    const menuRef = useRef(null);
    const buttonRef = useRef(null);
    const onClickOutsideMenu = (event) => {
        const clickedOnButton = !!buttonRef.current?.contains(event?.target);
        // If the menu is open and the user clicks on the call transfer button, both this and the
        //       transfer button's onClick handler will be invoked (this happens even if
        //       event.stopPropagation is added to both handlers).  When both run and the button's onClick
        //       handler is fired last, the menu is reopened.  To ensure the menu closes, we make
        //       this handler a no-op and allow the button's handler to toggle the menu.
        if (!clickedOnButton) {
            closeMenu();
        }
    };
    useSensor(onClickOutsideMenu, closeMenu, menuRef);
    return (_jsxs(Wrapper, { children: [_jsx(ButtonWithLabel, { ref: buttonRef, roundRightEdgeYn: roundRightEdgeYn, disabled: disabled, onClick: onClick, style: buttonStyle }), _jsx(Menu, { trades: trades, onRequeueTrade: onRequeueTrade, showYn: showMenuYn, ref: menuRef })] }));
}
const Wrapper = styled.span({
    position: 'relative',
    display: 'inline-flex',
});
//# sourceMappingURL=button_with_menu.js.map